<template>
  <v-container>
    <v-overlay :value="loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-col cols="12" lg="8" md="8" sm="12" v-if="typyWizyt && typyWizyt.length > 0">
      <v-select v-model="selectedType" :items="typyWizyt" label="Typ wizyty" item-text="nazwa" return-object></v-select>
    </v-col>
    <v-col cols="12" lg="8" md="8" sm="12" v-if="typyWizyt == null || typyWizyt.length == 0">
      <span>Długość wizyty: {{ilosc_minut}}</span>
    </v-col>
    <v-row align="start" justify="center" style="margin-top: 30px">
      <v-col cols="auto">
        <v-btn icon @click="previousDateChange" v-if="!hidePreviousDate">
          <v-icon>fa-angle-left</v-icon>
        </v-btn>
      </v-col>
      <v-col v-for="(item, dateIndex) in currentData" :key="dateIndex" cols="auto" class="date-column">
        <h3 class="text-center">{{ formatDate(item.date) }}</h3>
        <h4 class="text-center">{{ formatDayName(item.date) }}</h4>
        <v-col v-for="(hourItem, hourIndex) in item.hours" :key="hourIndex" class="hour-column" cols="auto">
          <v-btn small color="success" class="hour-button" @click="selectDate(hourItem)">{{ hourItem.hour }}</v-btn>
        </v-col>
      </v-col>
      <v-col cols="auto">
        <v-btn icon @click="nextDateChange" v-if="hasMoreRows">
          <v-icon>fa-angle-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {therapistsService} from "@/services";
import dayjs from "dayjs";
import 'dayjs/locale/pl'; 
export default {
  props:['therapistid', 'startDate', 'typWizytyId'],
  data() {
    return {
      selectedType: null,
      loading: false,
      initial: true,
      currentDate: null,
      ilosc_minut: 0,
      typyWizyt: [],
      hasMoreRows: false,
      currentData: [],
      datesPassed: [],
      hidePreviousDate: true,
      passedDate: null,
      availableDates: [
      /*  '2024-02-16',
        '2024-02-17',
        '2024-02-18',
        '2024-02-19',
        '2024-02-20',
        // Możesz dodać więcej dat*/
      ],
      availableHours: [
        /*'09:00', '10:00', '11:00', '12:00', '13:00',*/
        // Możesz dodać więcej godzin
      ]
    };
  },
  mounted() {
    this.getData(this.startDate, this.typWizytyId)
  },
  methods: {
    previousDateChange() {
      if(this.datesPassed.length > 0) {
        this.currentDate = this.datesPassed[this.datesPassed.length - 1]
        this.datesPassed = this.datesPassed.slice(0,-1)
        this.getData(this.currentDate.format('YYYY-MM-DD'))
      }
      else
      {
        this.currentDate = null
        this.getData()
      }
    },
    nextDateChange() {
      if(this.currentData.length > 0) {
        if(this.currentDate != null) {
          this.datesPassed.push(this.currentDate)
        }
        this.currentDate = dayjs(this.currentData[this.currentData.length - 1].date).add(1,'day')
        this.getData(this.currentDate.format('YYYY-MM-DD'))
      }
    },
    selectDate(item) {
      let argsData = {}
      argsData.StartTime =new dayjs(item.startDate).toDate()
      argsData.EndTime = new dayjs(item.endDate).toDate()
      argsData.therapistID = this.therapistid
      argsData.type = 'Day'
      if(this.selectedType != null)
      {
        argsData.typWizytyTerapeutyId = this.selectedType.id
      }
      this.$emit('datepicked',argsData)
    },
    formatDayName(date) {
      dayjs.locale('pl'); // Ustawiamy lokalizację na polską
      return dayjs(date).format('ddd'); // Formatujemy datę do skróconej nazwy dnia
    },
    getData(startDate,selectedTypWizytyId) {
      var data = {}
      data.startDate = startDate;
      data.typWizyty = selectedTypWizytyId != null && selectedTypWizytyId != 0 ? selectedTypWizytyId : (this.selectedType != null ? this.selectedType.id : 0);
      data.therapistId = this.therapistid;
      data.ileDat = 5;
      this.hasMoreRows = false;
      therapistsService.GetTherapistFreeShedules(data).then(result=> {

        if(result != null && result.data != null && result.data.result != null)
        {
          if(result.data.result.freeSchedules != null) {
            this.currentData = result.data.result.freeSchedules
            this.hasMoreRows = result.data.result.hasMoreDates
          }
          if(result.data.result.typyWizyt != null && result.data.result.typyWizyt.length > 0) {
            if(this.typyWizyt == null || this.typyWizyt.length == 0) {
              this.typyWizyt = result.data.result.typyWizyt
              this.selectedType = this.typyWizyt.find(elem => elem.id == result.data.result.wybranyTyp)
            }
            this.ilosc_minut = result.data.result.dlugoscWizyty
          }
          else {
            this.selectedType = null
            this.typyWizyt = []
          }
          this.hidePreviousDate = result.data.result.hidePreviousDate
          this.passedDate = dayjs(result.data.result.passedDate)
        }
      });
    },
    formatDate(date) {
      let d = dayjs(date)
      return d.format("DD-MM");
      //const parts = date.split('-');
      //return `${parts[2]}.${parts[1]}`;
    }
  },
  watch: {
    selectedType: {
      handler(newVal, oldVal) {        
        if(!this.initial && this.selectedType != null) {
          if(this.currentDate)
            this.getData(this.currentDate.format('YYYY-MM-DD'));
          else
            this.getData()
        }
        else if(this.selectedType != null)
        {
          this.initial = false
        }
      },
      immediate: false
    }
  },
};
</script>

<style scoped>
.date-column {
  padding: 0 10px;
  flex-grow: 0; /* Zatrzymanie rozciągania kolumny na całą dostępną przestrzeń */
}
.hour-column {
  display: flex;
  flex-direction: column;
  padding: 5px; /* Usunięcie wewnętrznych odstępów kolumny */
}
.hour-button {
  margin-bottom: 2px; /* zmniejszenie odstępu między przyciskami godzin */
  width: 60px; /* zmniejszenie szerokości przycisków */
  margin: auto; /* wyśrodkowanie przycisków */
}
</style>
